import {
    FETCH_SYSTEM_TYPES,
    SYSTEM_TYPES_LOAD_BEGIN,
    SYSTEM_TYPES_LOAD_END,
    SYSTEM_TYPES_LOAD_ERROR
} from '../actions/actionTypes';

const initialState = {
    data:    [],
    error:   null,
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SYSTEM_TYPES:
            return {
                ...state,
                data: action.payload
            };
        case SYSTEM_TYPES_LOAD_BEGIN:
            return {
                ...state,
                error:   initialState.error,
                loading: true
            };
        case SYSTEM_TYPES_LOAD_END:
            return {
                ...state,
                loading: false
            };
        case SYSTEM_TYPES_LOAD_ERROR:
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
};
